import { scrollToElement } from "@/lib/utils";
import { Link } from "wouter";
import { SafeImage } from "@/components/ui/safe-image";

export default function Footer() {
  const socialLinks = [
    { name: "Facebook", url: "https://www.facebook.com/MetodoBianchini/?locale=it_IT", icon: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" },
    { name: "Instagram", url: "https://www.instagram.com/metodobianchini_official/", icon: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" }
  ];

  const quickLinks = [
    { name: "Home", id: "home" },
    { name: "Il Metodo", id: "metodo" },
    { name: "Consulenze", id: "consulenze" },
    { name: "Press", id: "press" },
    { name: "Contatti", id: "contatti" }
  ];


  const handleLinkClick = (id: string) => {
    scrollToElement(id);
  };

  return (
    <footer className="relative overflow-hidden bg-[#0C1528] text-white pt-24 pb-8">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 right-0 bottom-0 overflow-hidden -z-10 pointer-events-none">
        <div className="absolute w-full h-52 top-0 left-0 bg-gradient-to-b from-background to-transparent"></div>
        <div className="absolute w-[700px] h-[700px] -top-96 right-0 bg-primary/5 rounded-full blur-[120px]"></div>
        <div className="absolute w-[500px] h-[500px] bottom-0 -left-60 bg-primary/10 rounded-full blur-[150px]"></div>
      </div>
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-6 mb-12">
          <div>
            <div className="flex items-start">
              <SafeImage
                src="logo-metodo-bianchini-white"
                alt="MetodoBianchini® Logo"
                className="h-14 mb-8"
                useFallbackService={true}
              />
            </div>
            <p className="text-white/60 mb-8 leading-relaxed">MetodoBianchini® <br />Un percorso alimentare – evolutivo per imparare a volersi bene con il cibo, raggiungendo o mantenendo la propria forma ideale.</p>
            <div className="flex space-x-5">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/50 hover:text-primary transition-all hover:scale-110 transform"
                  aria-label={link.name}
                >
                  <div className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center hover:border-primary/30">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                      <path d={link.icon} />
                    </svg>
                  </div>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:ml-8">
            <h3 className="text-lg font-montserrat font-semibold text-white mb-6 relative">
              <span className="relative z-10">Link Rapidi</span>
              <span className="absolute bottom-0 left-0 w-12 h-[2px] bg-primary/40"></span>
            </h3>
            <ul className="space-y-4">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={`#${link.id}`}
                    className="text-white/60 hover:text-primary transition-colors flex items-center"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLinkClick(link.id);
                    }}
                  >
                    <span className="mr-2 text-primary/60">&rsaquo;</span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>



          <div id="contatti">
            <h3 className="text-lg font-montserrat font-semibold text-white mb-6 relative">
              <span className="relative z-10">Contatti</span>
              <span className="absolute bottom-0 left-0 w-12 h-[2px] bg-primary/40"></span>
            </h3>
            <ul className="space-y-5">
              <li className="flex items-start">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <span className="text-white/60 ml-3">SALÒ – piazza Vittorio Emanuele II – n.42/B<br />(Complesso Gasparo)</span>
              </li>

              <li className="flex items-start">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <span className="text-white/60 ml-3">Lun-Ven: 9:00-12:00 / 14:30-19:00</span>
              </li>

              <li className="flex items-start">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <a href="tel:+393270289159" className="text-white/60 ml-3 hover:text-primary transition-colors">+39 327 028 9159</a>
              </li>

            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 mt-12">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/40 text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} MetodoBianchini®. Tutti i diritti riservati. | P. IVA IT 03849160985
            </p>
            <div className="flex space-x-6 text-sm text-white/40">
              <Link href="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link>
              <Link href="/cookie-policy" className="hover:text-primary transition-colors">Cookie Policy</Link>
              <Link href="/termini-condizioni" className="hover:text-primary transition-colors">Termini e Condizioni</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
